const items = [
  {
    id: 1,
    title: "HTML5/CSS3",
    category: "Pages",
    img: "https://miro.medium.com/max/792/1*lJ32Bl-lHWmNMUSiSq17gQ.png",
    desc: `HHTML CSS3 only elements and apps`,
    urlLink: "/htmlcss",
  },
  {
    id: 2,
    title: "JavaScript",
    category: "Pages",
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRJrRfrF329fKNxX5DAxPNO2EXiLmMyl54PrA&usqp=CAU",
    desc: `JavaScript HTML5 and CSS3`,
    urlLink: "/javascript",
  },
  {
    id: 3,
    title: "React",
    category: "Pages",
    img: "https://abcntechnologies.com/wp-content/uploads/2019/12/reactjs.png",
    desc: `React Apps`,
    urlLink: "/react",
  },
]

export default items
